export default {
    ko: {
        'design.layout': '카피 레이아웃',
        'design.background': '배경',
        'design.objet': '오브제',
        'design.button': '버튼',
        'design.shape': '형태',

        'content.keytopic': '주제',
        'content.keyword': '키워드',
        'content.trigger': '트리거',
        'content.adcopy': '카피',
        'content.benefit': '혜택',

        'category': '업종(대분류)',
        'subcategory': '업종(중분류)',
        'channel': '광고 채널',
        'admedia': '광고 상품',
        'media': '광고 매체',
        'adtype': '광고 유형',
        'account': '광고주',
        'device': '기기',
        'brand': '브랜드',
        'goal': '광고 목적',

        'all': '전체선택',
    },
    en: {
        'design.layout': 'Layout',
        'design.background': 'Background',
        'design.objet': 'Objet',
        'design.button': 'Button',
        'design.shape': 'Shape',

        'content.keytopic': 'Subject',
        'content.keyword': 'Keyword',
        'content.trigger': 'Trigger',
        'content.adcopy': 'Copy Text',
        'content.benefit': 'Benefit',

        'category': 'Category',
        'subcategory': 'Sub category',
        'channel': 'Ad Channel',
        'admedia': 'Ad Media',
        'media': 'Media Platform',
        'adtype': 'Ad Type',
        'account': 'Account',
        'device': 'Device',
        'brand': 'Brand',
        'goal': 'Object',

        'all': 'ALL',
    },
}